export default __webpack_public_path__ + "static/media/hella.a31c61da.jpg";